import { styles } from '@material-ui/pickers/views/Calendar/Calendar';
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import Style from "./index.module.scss";

function CustomModal({ isShowModal, onOk, onClose, title, caption, okText, closeText, children }) {
    return (
        <div>
            <Modal
                show={isShowModal}
                // onHide={() => onClose()}
                style={{ zIndex: 20000 }}
                className={Style.DeleteConfirmmodal}
                backdrop="static"
            >
                {/* <Modal.Header closeButton>
            <Modal.Title>Modal heading</Modal.Title>
          </Modal.Header> */}
                <Modal.Body>
                    <div>

                        {
                            title &&
                            <div>
                                {caption ? null : <div><br /></div>}
                                <h3 className={Style.HeaderText}>{title}</h3>
                            </div>
                        }

                       

                        <div className={Style.body}>
                            {children}
                        </div>


                        <div className={Style.BottomSection}>

                            {
                                okText &&
                                <Button
                                    variant="primary"
                                    className={Style.cancelBtn}
                                    onClick={onClose}
                                >
                                    {closeText ? closeText : "Close"}
                                </Button>
                            }

                            {
                                closeText &&
                                <Button
                                    variant="primary"
                                    className={Style.DeleteBtn}
                                    onClick={onOk}
                                >
                                    {
                                        okText ? okText : "OK"
                                    }
                                </Button>
                            }

                        </div>


                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={() => setShowModal(false)}>
              Save Changes
            </Button>
          </Modal.Footer> */}
            </Modal>
        </div>
    )
}

export default CustomModal